export const ATRAS = "Atrás";
export const GUARDAR = "Guardar";
export const ELIMINAR = "Eliminar";
export const EDITAR = "Editar";
export const CREAR = "Crear";
export const CERRAR = "Cerrar";
export const ACEPTAR = "Aceptar";
